/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

	import * as global from "../../../js/global";
	import * as helper from "../../../js/helper";
	import full_loading from "../../components/full-loading.vue";
	const __vue_script__ ={
        components: {
            full_loading:full_loading
        },
		name:'my-balance',
        props: { 
        },
		data() {
			return {
                global,
                helper,
                frappe,
                is_loading:false,
				balance_history: [],
                pending_payment: null,
                processed_payments: [],
                balance: 0,
                reason: null,
                ended_at: null,
                page:0,
                end_of_page:false,
                sort_by:'creation',
                order:'DESC',
			}
		},
        mounted(){
            this.load_data(true);
            global.emitter.on("get-transfer-balance", (args) => {
                global.emitter.emit("set-transfer-balance",this.balance);
            });
        },
		methods: {
            load_data: async function(reload=false){
                if(this.is_loading)
                    return;
                if(reload){
                    this.page = 0;
                    this.end_of_page = false;
                    while(this.balance_history.length > 0) {
                        this.balance_history.pop();
                    }
                }
                if(this.end_of_page)
                    return;
                global.emitter.emit("show-full-loading");
                this.is_loading = true;
                let params = {
                };
                let url = "/api/method/maalek.api.get_my_balance_list";
                let res = await $.ajax({
                    url: url,
                    type: "GET",
                    data: params
                });
                var running = 0;
                for (let index = 0; index < res.message["history"].length; index++) {
                    res.message["history"][index]['creation'] = helper.toMomentObj(res.message["history"][index]['creation']);
                    this.balance_history.push(res.message["history"][index]);
                }
                this.balance = res.message["balance"];
                this.pending_payment = res.message["pending_payment"]
                this.processed_payments = res.message["processed_payments"]
                for (let index = 0; index < res.message["processed_payments"].length; index++) {
                    res.message["processed_payments"][index]['creation'] = helper.toMomentObj(res.message["processed_payments"][index]['creation']);
                }
                global.emitter.emit("set-transfer-balance",this.balance);
                this.is_loading = false;
                global.emitter.emit("hide-full-loading");
            },
            askToCancelPaymentRequest: function(){
                bootbox.confirm({
                    message: `<div class="alert alert-danger" role="alert">
                            <b>`+helper.t("Do you want to cancel payment request?")+`</b><br>
                        </div>`,
                    buttons: {
                        confirm: {
                            label: helper.t("Yes"),
                            className: 'btn-success'
                        },
                        cancel: {
                            label: helper.t("No"),
                            className: 'btn-danger'
                        }
                    },
                    backdrop: true,
                    callback: (results) => results?this.cancel_payment_request():console.log("cancel"),
                });
            },
            cancel_payment_request: async function (){
                if(this.is_loading)
                    return;
                this.is_loading = true;
                global.emitter.emit("show-full-loading");
                let params = {
                    payment_request_name: this.pending_payment['name']
                };
                try {
                    let res = await $.ajax({
                        headers: { 'X-Frappe-CSRF-Token': frappe.csrf_token },
                        url: "/api/method/maalek.api.cancel_payment_request",
                        type: "POST",
                        // data: params //for GET request
                        data: JSON.stringify(params) //for POST request
                    });
                    this.pending_payment = null;
                    this.is_loading = false
                    this.error = false;
                    location.reload();
                    global.emitter.emit("hide-full-loading");
                } catch (e) {
                    this.error = true;
                    helper.showException(e);
                }
                global.emitter.emit("hide-full-loading");
                this.is_loading = false
            },
            openPendingPayment: function(){
                global.emitter.emit("set-pending-payment",this.pending_payment);
				$("#upload-transfer-modal").modal('show');
			},
            openModal: function(elementID){
				$(elementID).modal('show');
			},
            closeModal: function(elementID){
				$(elementID).modal('hide');
			}
		},
		computed:{
		}
	}

/* template */
var __vue_render__ = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { ref: "pagination_component" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "dashboard-interface-card" }, [
        _c("div", { staticClass: "row g-2 justify-content-center mb-2" }, [
          _c("div", { staticClass: "col-4" }, [
            _c("div", { staticClass: "single-interface-card" }, [
              _c("i", { staticClass: "fa-solid fa-caret-up" }),
              _vm._v(" "),
              _c("h3", { staticClass: "text-secondary" }, [
                _vm._v(_vm._s(_vm.helper.t("Balance (Adv.)")))
              ]),
              _vm._v(" "),
              _c("h4", { staticClass: "fw-bold" }, [
                _vm._v(
                  _vm._s(
                    _vm.helper.t("SR. {0}", [
                      _vm.balance < 0 ? Math.abs(_vm.balance) : 0
                    ])
                  )
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-4" }, [
            _c("div", { staticClass: "single-interface-card" }, [
              _c("i", { staticClass: "fa-solid fa-caret-down" }),
              _vm._v(" "),
              _c("h3", { staticClass: "text-secondary" }, [
                _vm._v(_vm._s(_vm.helper.t("Payables")))
              ]),
              _vm._v(" "),
              _c("h4", { staticClass: "fw-bold" }, [
                _vm._v(
                  _vm._s(
                    _vm.helper.t("SR. {0}", [
                      _vm.balance > 0 ? Math.abs(_vm.balance) : 0
                    ])
                  )
                )
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row g-2 justify-content-center" }, [
          _c("div", { staticClass: "col-4" }, [
            _vm.is_loading
              ? _c(
                  "div",
                  {
                    staticClass:
                      "single-interface-card d-flex justify-content-center py-4",
                    attrs: { role: "button" }
                  },
                  [_c("i", { staticClass: "fa-solid fa-sync fa-spin" })]
                )
              : !_vm.pending_payment
              ? _c(
                  "div",
                  {
                    staticClass: "single-interface-card",
                    attrs: { role: "button" },
                    on: {
                      click: function($event) {
                        return _vm.openModal("#upload-transfer-modal")
                      }
                    }
                  },
                  [
                    _c("i", { staticClass: "fa-solid fa-wallet" }),
                    _vm._v(" "),
                    _c("h3", { staticClass: "text-secondary" }, [
                      _vm._v(_vm._s(_vm.helper.t("Online Payment")))
                    ]),
                    _vm._v(" "),
                    _c("h4", { staticClass: "fw-bold" }, [
                      _vm._v(_vm._s(_vm.helper.t("Click here")))
                    ])
                  ]
                )
              : _c(
                  "div",
                  {
                    staticClass:
                      "single-interface-card d-flex justify-content-around py-4"
                  },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "btn btn-secondary",
                        attrs: { role: "button" },
                        on: {
                          click: function($event) {
                            return _vm.askToCancelPaymentRequest()
                          }
                        }
                      },
                      [_c("p", [_vm._v(_vm._s(_vm.helper.t("Cancel")))])]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "btn btn-primary",
                        attrs: { role: "button", target: "_blank" },
                        on: {
                          click: function($event) {
                            return _vm.openPendingPayment()
                          }
                        }
                      },
                      [
                        _c("p", [
                          _vm._v(
                            _vm._s(_vm.helper.t("Pending Payment Request"))
                          )
                        ])
                      ]
                    )
                  ]
                )
          ]),
          _vm._v(" "),
          _vm._m(0)
        ])
      ])
    ]),
    _vm._v(" "),
    _c("table", { staticClass: "table table-striped table-hover" }, [
      _c("thead", [
        _c("tr", [
          _c("th", { attrs: { scope: "col" } }, [
            _vm._v(_vm._s(_vm.helper.t("Date")))
          ]),
          _vm._v(" "),
          _c("th", { attrs: { scope: "col" } }, [
            _vm._v(_vm._s(_vm.helper.t("Ref#")))
          ]),
          _vm._v(" "),
          _c("th", { staticClass: "text-end", attrs: { scope: "col" } }, [
            _vm._v(_vm._s(_vm.helper.t("Remarks")))
          ]),
          _vm._v(" "),
          _c("th", { staticClass: "text-end", attrs: { scope: "col" } }, [
            _vm._v(_vm._s(_vm.helper.t("Amount")))
          ]),
          _vm._v(" "),
          _c("th", { staticClass: "text-end", attrs: { scope: "col" } }, [
            _vm._v(_vm._s(_vm.helper.t("Balance")))
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "tbody",
        [
          _vm._l(_vm.processed_payments, function(processed_payment) {
            return [
              _c("tr", [
                _c("td", { staticClass: "text-start", attrs: { dir: "ltr" } }, [
                  _vm._v(
                    _vm._s(processed_payment["creation"].format("DD-MMM-YYYY"))
                  )
                ]),
                _vm._v(" "),
                _c("td", [_vm._v(" - ")]),
                _vm._v(" "),
                _c("td", { staticClass: "fw-bold text-end text-muted" }, [
                  _vm._v(_vm._s(_vm.helper.t("Processing")))
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "text-end" }, [
                  _c("h5", { staticClass: "text-muted" }, [
                    _vm._v(
                      "\n                            " +
                        _vm._s(Math.abs(processed_payment["amount"])) +
                        "\n                            "
                    ),
                    _c("i", { staticClass: "fa-solid fa-hourglass-half" })
                  ])
                ]),
                _vm._v(" "),
                _vm._m(1, true)
              ])
            ]
          }),
          _vm._v(" "),
          _vm._l(_vm.balance_history, function(history) {
            return [
              _c("tr", [
                _c("td", { staticClass: "text-start", attrs: { dir: "ltr" } }, [
                  _vm._v(_vm._s(history["creation"].format("DD-MMM-YYYY")))
                ]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(history["referance"]))]),
                _vm._v(" "),
                _c(
                  "td",
                  {
                    staticClass: "fw-bold text-end",
                    class:
                      history["amount"] < 0 ? "text-success" : "text-danger"
                  },
                  [
                    _vm._v(
                      _vm._s(
                        history["amount"] > 0
                          ? _vm.helper.t("Payable")
                          : _vm.helper.t("Paid")
                      )
                    )
                  ]
                ),
                _vm._v(" "),
                _c("td", { staticClass: "text-end" }, [
                  _c(
                    "h5",
                    {
                      class:
                        history["amount"] < 0 ? "text-success" : "text-danger"
                    },
                    [
                      _vm._v(
                        "\n                            " +
                          _vm._s(Math.abs(history["amount"])) +
                          "\n                            "
                      ),
                      _c("i", {
                        staticClass: "fa-solid",
                        class:
                          history["amount"] < 0
                            ? "fa-caret-up"
                            : "fa-caret-down"
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "text-end" }, [
                  _c("h6", [
                    _vm._v(
                      "\n                            " +
                        _vm._s(Math.abs(history["running"])) +
                        "\n                        "
                    )
                  ])
                ])
              ])
            ]
          })
        ],
        2
      )
    ])
  ])
}
var __vue_staticRenderFns__ = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-4" }, [
      _c("img", {
        staticStyle: { height: "50px" },
        attrs: { src: "/assets/maalek/images/snb-bank.png", alt: "Image" }
      }),
      _vm._v(" "),
      _c("h6", [_vm._v("شركة تطبيق مالك للخدمات العقارية")]),
      _vm._v(" "),
      _c("h6", [_vm._v("SA1910000051200000257609")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { staticClass: "text-end" }, [_c("h6", [_vm._v(" - ")])])
  }
]
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-02506b68_0", { source: "\n.modal-content{\n    overflow: visible !important;\n}\n.modal-body{\n    overflow: unset !important;\n}\n", map: {"version":3,"sources":["../maalek/maalek/public/vue/widgets/account/my-balance.vue"],"names":[],"mappings":";AAqPA;IACA,4BAAA;AACA;AACA;IACA,0BAAA;AACA","file":"my-balance.vue","sourcesContent":["<template>\n    <div ref=\"pagination_component\">\n        <div class=\"row\">\n            <div class=\"dashboard-interface-card\">\n                <div class=\"row g-2 justify-content-center mb-2\">\n                    <div class=\"col-4\">\n                        <div class=\"single-interface-card\">\n                            <i class=\"fa-solid fa-caret-up\"></i>\n                            <h3 class=\"text-secondary\">{{ helper.t(\"Balance (Adv.)\") }}</h3>\n                            <h4 class=\"fw-bold\">{{ helper.t(\"SR. {0}\",[balance<0?Math.abs(balance):0]) }}</h4>\n                        </div>\n                    </div>\n                    <div class=\"col-4\">\n                        <div class=\"single-interface-card\">\n                            <i class=\"fa-solid fa-caret-down\"></i>\n                            <h3 class=\"text-secondary\">{{ helper.t(\"Payables\") }}</h3>\n                            <h4 class=\"fw-bold\">{{ helper.t(\"SR. {0}\",[balance>0?Math.abs(balance):0]) }}</h4>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"row g-2 justify-content-center\">\n                    <div class=\"col-4\">\n                        <div v-if=\"is_loading\"\n                            class=\"single-interface-card d-flex justify-content-center py-4\"\n                            role=\"button\">\n                            <i class=\"fa-solid fa-sync fa-spin\"></i>\n                        </div>\n                        <div v-else-if=\"!pending_payment\"\n                            @click=\"openModal('#upload-transfer-modal')\"\n                            class=\"single-interface-card\"\n                            role=\"button\">\n                            <i class=\"fa-solid fa-wallet\"></i>\n                            <h3 class=\"text-secondary\">{{ helper.t(\"Online Payment\") }}</h3>\n                            <h4 class=\"fw-bold\">{{ helper.t(\"Click here\") }}</h4>\n                        </div>\n                        <div v-else class=\"single-interface-card d-flex justify-content-around py-4\">\n                            <a class=\"btn btn-secondary\"\n                                role=\"button\"\n                                @click=\"askToCancelPaymentRequest()\">\n                                <p>{{ helper.t(\"Cancel\") }}</p>\n                            </a>\n                            <a class=\"btn btn-primary\"\n                                role=\"button\"\n                                target=\"_blank\"\n                                @click=\"openPendingPayment()\">\n                                <p>{{ helper.t(\"Pending Payment Request\") }}</p>\n                            </a>\n                        </div>\n                    </div>\n                    <div class=\"col-4\">\n                        <img src=\"/assets/maalek/images/snb-bank.png\" style=\"height: 50px;\" alt=\"Image\">\n                        <h6>شركة تطبيق مالك للخدمات العقارية</h6>\n                        <h6>SA1910000051200000257609</h6>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <table class=\"table table-striped table-hover\">\n            <thead>\n                <tr>\n                    <th scope=\"col\">{{ helper.t(\"Date\") }}</th>\n                    <th scope=\"col\">{{ helper.t(\"Ref#\") }}</th>\n                    <th scope=\"col\" class=\"text-end\">{{ helper.t(\"Remarks\") }}</th>\n                    <th scope=\"col\" class=\"text-end\">{{ helper.t(\"Amount\") }}</th>\n                    <th scope=\"col\" class=\"text-end\">{{ helper.t(\"Balance\") }}</th>\n                </tr>\n            </thead>\n            <tbody>\n                <template v-for=\"processed_payment in processed_payments\">\n                    <tr>\n                        <td dir=\"ltr\" class=\"text-start\">{{ processed_payment['creation'].format(\"DD-MMM-YYYY\") }}</td>\n                        <td> - </td>\n                        <td class=\"fw-bold text-end text-muted\">{{ helper.t(\"Processing\") }}</td>\n                        <td class=\"text-end\">\n                            <h5 class=\"text-muted\">\n                                {{ Math.abs(processed_payment['amount']) }}\n                                <i class=\"fa-solid fa-hourglass-half\"></i>\n                            </h5>\n                        </td>\n                        <td class=\"text-end\">\n                            <h6> - </h6>\n                        </td>\n                    </tr>\n                </template>\n                <template v-for=\"history in balance_history\">\n                    <tr>\n                        <td dir=\"ltr\" class=\"text-start\">{{ history['creation'].format(\"DD-MMM-YYYY\") }}</td>\n                        <td>{{ history['referance'] }}</td>\n                        <td class=\"fw-bold text-end\" :class='history[\"amount\"]<0?\"text-success\":\"text-danger\"'>{{ history[\"amount\"]>0?helper.t(\"Payable\"):helper.t(\"Paid\") }}</td>\n                        <td class=\"text-end\">\n                            <h5 :class='history[\"amount\"]<0?\"text-success\":\"text-danger\"'>\n                                {{ Math.abs(history['amount']) }}\n                                <i class=\"fa-solid\" :class=\"history['amount']<0?'fa-caret-up':'fa-caret-down'\"></i>\n                            </h5>\n                        </td>\n                        <td class=\"text-end\">\n                            <h6>\n                                {{ Math.abs(history['running']) }}\n                            </h6>\n                        </td>\n                    </tr>\n                </template>\n            </tbody>\n        </table>\n    </div>\n</template>\n\n<script>\n\timport * as global from \"../../../js/global\";\n\timport * as helper from \"../../../js/helper\";\n\timport full_loading from \"../../components/full-loading.vue\";\n\texport default{\n        components: {\n            full_loading:full_loading\n        },\n\t\tname:'my-balance',\n        props: { \n        },\n\t\tdata() {\n\t\t\treturn {\n                global,\n                helper,\n                frappe,\n                is_loading:false,\n\t\t\t\tbalance_history: [],\n                pending_payment: null,\n                processed_payments: [],\n                balance: 0,\n                reason: null,\n                ended_at: null,\n                page:0,\n                end_of_page:false,\n                sort_by:'creation',\n                order:'DESC',\n\t\t\t}\n\t\t},\n        mounted(){\n            this.load_data(true);\n            global.emitter.on(\"get-transfer-balance\", (args) => {\n                global.emitter.emit(\"set-transfer-balance\",this.balance);\n            });\n        },\n\t\tmethods: {\n            load_data: async function(reload=false){\n                if(this.is_loading)\n                    return;\n                if(reload){\n                    this.page = 0;\n                    this.end_of_page = false;\n                    while(this.balance_history.length > 0) {\n                        this.balance_history.pop();\n                    }\n                }\n                if(this.end_of_page)\n                    return;\n                global.emitter.emit(\"show-full-loading\");\n                this.is_loading = true;\n                let params = {\n                };\n                let url = \"/api/method/maalek.api.get_my_balance_list\";\n                let res = await $.ajax({\n                    url: url,\n                    type: \"GET\",\n                    data: params\n                });\n                var running = 0;\n                for (let index = 0; index < res.message[\"history\"].length; index++) {\n                    res.message[\"history\"][index]['creation'] = helper.toMomentObj(res.message[\"history\"][index]['creation']);\n                    this.balance_history.push(res.message[\"history\"][index]);\n                }\n                this.balance = res.message[\"balance\"];\n                this.pending_payment = res.message[\"pending_payment\"]\n                this.processed_payments = res.message[\"processed_payments\"]\n                for (let index = 0; index < res.message[\"processed_payments\"].length; index++) {\n                    res.message[\"processed_payments\"][index]['creation'] = helper.toMomentObj(res.message[\"processed_payments\"][index]['creation']);\n                }\n                global.emitter.emit(\"set-transfer-balance\",this.balance);\n                this.is_loading = false;\n                global.emitter.emit(\"hide-full-loading\");\n            },\n            askToCancelPaymentRequest: function(){\n                bootbox.confirm({\n                    message: `<div class=\"alert alert-danger\" role=\"alert\">\n                            <b>`+helper.t(\"Do you want to cancel payment request?\")+`</b><br>\n                        </div>`,\n                    buttons: {\n                        confirm: {\n                            label: helper.t(\"Yes\"),\n                            className: 'btn-success'\n                        },\n                        cancel: {\n                            label: helper.t(\"No\"),\n                            className: 'btn-danger'\n                        }\n                    },\n                    backdrop: true,\n                    callback: (results) => results?this.cancel_payment_request():console.log(\"cancel\"),\n                });\n            },\n            cancel_payment_request: async function (){\n                if(this.is_loading)\n                    return;\n                this.is_loading = true;\n                global.emitter.emit(\"show-full-loading\");\n                let params = {\n                    payment_request_name: this.pending_payment['name']\n                };\n                try {\n                    let res = await $.ajax({\n                        headers: { 'X-Frappe-CSRF-Token': frappe.csrf_token },\n                        url: \"/api/method/maalek.api.cancel_payment_request\",\n                        type: \"POST\",\n                        // data: params //for GET request\n                        data: JSON.stringify(params) //for POST request\n                    });\n                    this.pending_payment = null;\n                    this.is_loading = false\n                    this.error = false;\n                    location.reload();\n                    global.emitter.emit(\"hide-full-loading\");\n                } catch (e) {\n                    this.error = true;\n                    helper.showException(e);\n                }\n                global.emitter.emit(\"hide-full-loading\");\n                this.is_loading = false\n            },\n            openPendingPayment: function(){\n                global.emitter.emit(\"set-pending-payment\",this.pending_payment);\n\t\t\t\t$(\"#upload-transfer-modal\").modal('show');\n\t\t\t},\n            openModal: function(elementID){\n\t\t\t\t$(elementID).modal('show');\n\t\t\t},\n            closeModal: function(elementID){\n\t\t\t\t$(elementID).modal('hide');\n\t\t\t}\n\t\t},\n\t\tcomputed:{\n\t\t}\n\t}\n</script>\n\n\n<style>\n    .modal-content{\n        overflow: visible !important;\n    }\n    .modal-body{\n        overflow: unset !important;\n    }\n</style>"]}, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "../maalek/maalek/public/vue/widgets/account/my-balance.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (false && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__